<!-- spinner -->
<div
  [style.width]="size + 'px'"
  [style.height]="size + 'px'"
  [style.border-width]="borderWidth + 'px'"
  [style.animationDuration]="periodSec + 's'"
  class="ts-spinner"
></div>
